module.exports = require("buffer");


//////////////////
// WEBPACK FOOTER
// external "buffer"
// module id = 18
// module chunks = 0